import { axiosInstance, trackEvent } from "@hopper-b2b/api";
import { NETWORK_CALL_FAILED } from "@hopper-b2b/types";
import { apiConfig } from "../../utils/urlPaths";
import { fetchUserInfoPath } from "../paths";

export type FetchUserInfoRequest = unknown;

export interface PortalAccess {
  flights: boolean;
  hotels: boolean;
  myTrips: boolean;
  support: boolean;
}

export interface NubankUserInfo {
  name: string;
  email: string;
  userId: string;
  preferredName?: string;
  taxId: string;
  phoneNumber?: string;
  partnerExperiments: string;
  kustomerAccessToken: string;
  isFirstSession: boolean;
  portalAccess?: PortalAccess;
}

export const fetchUserInfo = (
  userInfoRequest: FetchUserInfoRequest
): Promise<NubankUserInfo> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        fetchUserInfoPath,
        userInfoRequest
      );
      resolve(response.data);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
export default fetchUserInfo;
